<template>
  <vs-popup
    id="modal-painel-comercial"
    :active="isVisible"
    @close="closeModal"
    :class="`modal-style ${fullscreen ? 'modalWidthFull' : ''}`"
  >
    <div class="modal-content">
      <header class="py-4 px-6 flex justify-between sticky left-0">
        <strong class="vs-popup-title">{{ title }}</strong>
        <button
          @click="handleCloseButtonClick"
          class="close-button rounded-full flex items-center justify-center p-2"
        >
          <XIcon class="icon" />
        </button>
      </header>
      <table class="modal-table">
        <thead>
          <tr>
            <th v-for="(header, index) in headersProps" :key="index">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody v-if="isConsultorData">
          <tr v-for="(item, index) in sortedModalData" :key="index">
            <td v-if="headerExist('Nome')">{{ item.nome }}</td>
            <td v-if="headerExist('Vendas Pagas')">
              {{ item.totalVendas }}
            </td>
            <td v-if="headerExist('Cancelados')">{{ item.cancelados }}</td>
            <td v-if="headerExist('Pix em Aberto')">
              {{ item.inadPrimeiraParcela }}
            </td>
            <td v-if="headerExist('Relógio')">
              <div class="flex items-center justify-center gap-1">
                <span>{{ item.relogio ? item.relogio : 0 }}</span>
                <span class="text-xxs"
                  >({{
                    calculatePercentage(item.totalVendas, item.relogio)
                  }}%)</span
                >
              </div>
            </td>
            <td v-if="headerExist('Diferença p/ Relógio')">
              {{ item.diferencaRelogio }}
            </td>
            <td v-if="headerExist('Meta')">{{ item.metaTotal }}</td>
            <td v-if="headerExist('Diferença p/ Meta')">
              {{ item.diferencaMeta }}
            </td>
            <td v-if="headerExist('Valor 1⁠ª Parcela')">
              {{ item.valorPrimeiraParcela }}
            </td>
            <td v-if="headerExist('Projeções Futuras')">
              {{ item.somaMensalidade }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="(item, index) in sortedModalData" :key="index">
            <td>{{ item.nome }}</td>
            <td class="cpfcnpj" @click="navigateToDetail(item.id_prospect)">
              {{ item.cpfcnpj }}
            </td>
            <td>{{ item.id_proposta }}</td>
            <td>{{ item.placa ? item.placa : item.chassi }}</td>
            <td>R$ {{ item.valor_boleto }}</td>
            <td>{{ item.celular }}</td>
            <td>{{ item.situacao }}</td>
            <td>{{ item.id_empresa }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
import { XIcon } from 'vue-feather-icons';

export default {
  name: 'ModalComponent',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    modalData: {
      type: Array,
    },
    title: {
      type: String,
    },
    headers: {
      type: Array,
      default: () => [
        'Nome do Beneficiário',
        'CPF/CNPJ',
        'ID Proposta',
        'Placa/Chassi',
        'Valor',
        'Telefone',
        'Situação',
        'Empresa'
      ],
    },
    isConsultorData: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    XIcon,
  },

  data() {
    return {
      headersProps: this.headers,
    };
  },
  computed: {
    sortedModalData() {
      const isNotArray = !Array.isArray(this.modalData);
      if (isNotArray) {
        return [];
      }

      const sortedData = [...this.modalData].sort((firstItem, secondItem) => {
        return firstItem.nome.localeCompare(secondItem.nome);
      });

      return sortedData;
    },
    calculatePercentage() {
      return (totalVendas, relogio) => {
        if (!relogio) {
          return '0.00';
        }
        const percentage = (totalVendas / relogio) * 100;
        return isFinite(percentage) ? percentage.toFixed(2) : '0.00';
      };
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:isVisible', false);
    },
    handleCloseButtonClick(event) {
      event.stopPropagation();
      this.closeModal();
    },
    navigateToDetail(idProspect) {
      window.open(`/DetalheAssociado/${idProspect}`, '_blank');
    },
    headerExist(header) {
      const headersHasheader = this.headers.includes(header);
      return headersHasheader;
    },
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

#modal-painel-comercial .vs-popup--header {
  display: none;
}

.modalWidthFull .vs-popup {
  width: 100%;
  padding: 0;
}

#modal-painel-comercial .vs-popup {
  border-radius: 10px;
  overflow: hidden;
  max-width: 1200px;
  margin: auto;
}

#modal-painel-comercial .vs-popup--content {
  display: block;
  overflow-y: auto;
  scrollbar-color: #114880 transparent;
  scrollbar-width: thin;
}

#modal-painel-comercial .modal-content::-webkit-scrollbar-button {
  display: none;
}

#modal-painel-comercial .modal-content {
  background-color: #fff;
}

#modal-painel-comercial .modal-table {
  width: 100%;
  border-collapse: collapse;
}

#modal-painel-comercial .modal-table thead th {
  color: #0f4173;
  border-bottom: 1px solid #0f4173;
  padding: 12px 8px;
  text-align: left;
  white-space: nowrap;
  font-weight: 500;
}

#modal-painel-comercial .modal-table tbody {
  background-color: #fff;
}

#modal-painel-comercial .modal-table tbody tr:nth-child(even) {
  background-color: #cfdae6;
}

#modal-painel-comercial .modal-table tbody td {
  padding: 12px 8px;
  text-align: left;
  white-space: nowrap;
  font-size: 0.875rem;
}

#modal-painel-comercial .vs-popup-close {
  color: white;
  font-size: 1.25rem;
}

#modal-painel-comercial header strong {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #434343;
}

#modal-painel-comercial .icon {
  width: 12px;
  height: 12px;
  color: #fff;
}

#modal-painel-comercial .close-button {
  border: none;
  background: none;
  cursor: pointer;
  background-color: #0f4173;
}

#modal-painel-comercial .modal-content {
  overflow-x: auto;
}

#modal-painel-comercial .cpfcnpj {
  color: #0f4173;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.text-xxs {
  font-size: 0.625rem;
  line-height: 1rem;
}
</style>
